import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '../../icons';
import { VisuallyHidden } from '../../atoms';
import {
  Card,
  Info,
  Image,
  Name,
  Description,
  Label,
  CheckboxContainer,
  Pill,
  MoreDetails,
  CardContent,
  DisplayedPrice,
  StrikeThroughPrice,
} from './styles.js';

export const ProductCard = ({
  label,
  title,
  unavailable,
  value,
  description,
  checked = false,
  onDetailsClick,
  shouldShowMoreDetails = true,
  img,
  onChange,
  benefit,
  unavailableText,
  unavailableLabel,
  inputType = 'checkbox',
  pricingInfo = null,
  callout,
}) => {
  let labelText = label;
  if (unavailable) {
    labelText = unavailableLabel || 'Unavailable';
  } else if (checked) {
    labelText = 'Selected';
  }

  return (
    <Card checked={checked} unavailable={unavailable}>
      <Image unavailable={unavailable} src={img.src} alt={img.alt} />
      <CardContent>
        <Info>
          <Name>{title}</Name>
          {pricingInfo && !unavailable && (
            <div>
              {!pricingInfo.discount ? (
                <DisplayedPrice>{pricingInfo.price}</DisplayedPrice>
              ) : (
                <>
                  <DisplayedPrice>{pricingInfo.discount}</DisplayedPrice>
                  <StrikeThroughPrice>{pricingInfo.price}</StrikeThroughPrice>
                </>
              )}
            </div>
          )}
          {benefit && (
            <Pill unavailable={unavailable} type="benefit">
              {benefit}
            </Pill>
          )}
          {callout && (
            <Pill unavailable={unavailable} type="callout">
              {callout}
            </Pill>
          )}
          <Description>
            {unavailable ? unavailableText : description}
          </Description>
        </Info>

        {shouldShowMoreDetails && (
          <MoreDetails
            type="button"
            unavailable={unavailable}
            onClick={onDetailsClick}
          >
            Details
            <Icon iconName="plus-circle" alt="" size={1} color="border.fur" />
          </MoreDetails>
        )}

        <CheckboxContainer
          checked={checked && !unavailable}
          unavailable={unavailable}
        >
          <Label
            htmlFor={`${value}-checkbox-input`}
            checked={checked && !unavailable}
            unavailable={unavailable}
          >
            <VisuallyHidden>
              <input
                type={inputType}
                id={`${value}-checkbox-input`}
                name={value}
                checked={checked && !unavailable}
                disabled={unavailable}
                onChange={() => onChange()}
              />
            </VisuallyHidden>
            <VisuallyHidden>{label}</VisuallyHidden>
          </Label>
          {labelText}
        </CheckboxContainer>
      </CardContent>
    </Card>
  );
};

ProductCard.displayName = 'ProductCard';
ProductCard.propTypes = {
  label: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  benefit: PropTypes.string,
  inputType: PropTypes.oneOf(['checkbox', 'radio']),
  unavailableText: PropTypes.string,
  unavailableLabel: PropTypes.string,
  value: PropTypes.string.isRequired,
  description: PropTypes.node.isRequired,
  checked: PropTypes.bool,
  unavailable: PropTypes.bool,
  img: PropTypes.shape({
    src: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
  }).isRequired,
  pricingInfo: PropTypes.shape({
    price: PropTypes.string,
    discount: PropTypes.string,
  }),
  onChange: PropTypes.func.isRequired,
  onDetailsClick: PropTypes.func,
  callout: PropTypes.string,
  shouldShowMoreDetails: PropTypes.bool,
};
